module.exports = __webpack_public_path__ + "img/profile_blue.dcbd4a5d.png";